import { render, staticRenderFns } from "./StudentLeaveSubRecord.vue?vue&type=template&id=64708591&scoped=true&"
import script from "./StudentLeaveSubRecord.vue?vue&type=script&lang=js&"
export * from "./StudentLeaveSubRecord.vue?vue&type=script&lang=js&"
import style0 from "./StudentLeaveSubRecord.vue?vue&type=style&index=0&id=64708591&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64708591",
  null
  
)

export default component.exports